import { Loader } from 'semantic-ui-react';

import { useDebounce } from 'hooks';
import styled from '@emotion/styled';

type Props = {
  isFetching?: boolean;
  inline?: boolean | 'centered';
  margin?: string;
};

export const DebouncedLoader = ({ isFetching, inline, margin }: Props) => {
  const showLoader = useDebounce(250);
  return showLoader && (isFetching ?? true) ? (
    <S.Wrapper margin={margin}>
      <Loader active inline={inline} />
    </S.Wrapper>
  ) : null;
};

const S = {
  Wrapper: styled.div<{ margin?: string }>`
    display: flex;
    align-items: center;
    margin: ${(props) => props.margin};
  `,
};
